import { render, staticRenderFns } from "./InventoryMovementsHistory.vue?vue&type=template&id=5f809fc9&scoped=true&lang=pug"
import script from "./InventoryMovementsHistory.vue?vue&type=script&lang=js"
export * from "./InventoryMovementsHistory.vue?vue&type=script&lang=js"
import style0 from "./InventoryMovementsHistory.vue?vue&type=style&index=0&id=5f809fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f809fc9",
  null
  
)

export default component.exports